// src/data/useBoxes.js
import { useState, useEffect } from "react";

const BASE = "https://teardrophydro.co.uk/garageFarm";

export function useBoxes() {
  const [boxes, setBoxes]     = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError]     = useState(null);

  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        const res  = await fetch(`${BASE}/boxes`);
        if (!res.ok) throw new Error(`${res.status} ${res.statusText}`);
        const data = await res.json();
        if (alive) setBoxes(Array.isArray(data) ? data : []);
      } catch (e) {
        if (alive) setError(e.message);
      } finally {
        if (alive) setLoading(false);
      }
    })();
    return () => { alive = false; };
  }, []);

  return { boxes, loading, error };
}